export default class PageProgressBar {
    constructor(holder) {
        this.holder = holder

        if (!this.holder) return
        this.line = this.holder.querySelector('.js-page-progress-line')

        this.init()
    }

    init() {
        this.attachHandlers()
    }

    attachHandlers() {
        window.addEventListener('load', () => {
            this.initialBarProperty()
            this.progressBarHandler()
        })

        window.addEventListener('resize', () => {
            this.initialBarProperty()
        })

        window.addEventListener('scroll', () => {
            this.progressBarHandler()
        })
    }

    initialBarProperty() {
        this.getBarTopPosition()
    }

    getBarTopPosition() {
        this.barTopPosition = this.holder.offsetTop
    }

    checkThatScrollIsBelowBar() {
        const fromTop = window.pageYOffset

        return fromTop >= this.barTopPosition
    }

    checkThatScrollIsAboveBar() {
        const fromTop = window.pageYOffset

        return fromTop < this.barTopPosition
    }

    progressBarHandler() {
        const totalScroll = document.documentElement.scrollTop
        const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
        const scroll = `${(totalScroll / windowHeight) * 100}`

        this.line.style.width = scroll + '%'
    }
}
